import Moment from "react-moment";
import { useState } from "react";
import { IconSvg } from "../../../../../../../utils/constants/icons/iconSvg.constant";
import { classNames } from "../../../../../../../utils/helpers/classNames";
import { useTranslation } from "../../../../../../../hooks";
import { ItemDetailsTable } from "../ItemDetailsTable/ItemDetailsTable";

export const HistoryItem = ({ row }) => {
  const {
    creditCard: { card },
    cabinet: { balance: { title: balanceLabel, operationTypeMessages: { orderBuy, replenishment, orderExtend, orderAutoExtend } } }
  } = useTranslation();

  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const isNotReplenishment = row?.paymentAction !== "REPLENISHMENT";

  // const [detailedInfo, setDetailedInfo] = useState(false);

  // const getBalanceDetailedInfo = async () => {
  //   try {
  //     const { data, status } = await ApiService.getBalanceDetailedInfo(row?.paymentId);
  //
  //     if (status !== 200) throw new Error();
  //
  //     return data;
  //
  //   } catch (e) {
  //     errorToast("Something went wrong", lang);
  //   }
  // };

  // const detailsHandler = async () => {
  //   if (isDetailsOpen) {
  //     setIsDetailsOpen(false);
  //     return;
  //   }
  //
  //   const data = await getBalanceDetailedInfo();
  //
  //   if (!data) return;
  //
  //   setDetailedInfo(data);
  //   setIsDetailsOpen(true);
  // };

  const detailsHandler = () => {
    if (isNotReplenishment) setIsDetailsOpen((current) => !current);
  };

  const {
    cabinet: {
      balance: { detailPayment }
    }
  } = useTranslation();

  const getPaymentType = (type) => {
    const types = {
      BALANCE: balanceLabel,
      PADDLE_CARD: card
    };

    return types[type];
  };

  const getOperationType = (operationType, autoextend) => {
    if (operationType === "ORDER_EXTEND") {
      return autoextend ? orderAutoExtend : orderExtend;
    }

    const types = {
      "ORDER_BUY": `${orderBuy}:`,
      "REPLENISHMENT": replenishment
    };

    return types[operationType];
  };

  return (
    <>
      <li
        className={classNames(
          "history__list__item",
          { "history__list__item--active": isDetailsOpen }
        )}
        onClick={() => detailsHandler()}
      >
        <div className={classNames(
          "history__list__item-contain",
          { "history__list__item-contain--active": isDetailsOpen }
        )}>
          <div className="history__list__item-box">
            <div className="history__list__item-date">
              <Moment
                format="DD.MM.YYYY"
                utc={false}
                date={row?.date}
              />
            </div>
            <div className="history__list__item-amount">
              <span>{`${row?.paymentAction !== "REPLENISHMENT" ? "-" : "+"}$${row?.amount}`}</span>
            </div>
            <div className="history__list__item-payment-type">
              {row?.paymentSystemName || getPaymentType(row?.balanceType)}
            </div>
          </div>
          <div className="history__list__item-status">
            {getOperationType(row?.paymentAction, row?.autoextend)}
            {/*<><br />{row?.orderId}</>*/}
            {row?.paymentAction === "ORDER_BUY" && <><br />{row?.orderId}</>}
          </div>
          {isNotReplenishment ? (
            <div className="history__item-details-button">
              <div className="user-notifications-card__button-label">
                {detailPayment.details}
              </div>
              <IconSvg
                tag="arrow"
                className={classNames(
                  "history__item-button-icon",
                  { "history__item-button-icon--open": isDetailsOpen }
                )}
              />
            </div>
          ) : <div className="history__item-details-button"></div>}
        </div>
        {isNotReplenishment && <ItemDetailsTable isOpen={isDetailsOpen} detailedInfo={row} />}
      </li>
    </>
  );
};
